import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';

const NumericPasswordInput = ({ value, onChange, maxLength = 20, ...rest }) => {
  const handleChange = (e) => {
    const rawValue = e.target.value;
    const cleanedValue = rawValue.replace(/\D/g, '').slice(0, maxLength);
    onChange?.(cleanedValue);
  };

  const handleKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Input.Password
      {...rest}
      value={value}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      maxLength={maxLength}
      inputMode="numeric"
      placeholder={`Enter up to ${maxLength} digits`}
    />
  );
};

NumericPasswordInput.propTypes = {
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default NumericPasswordInput;
